import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { EXTRACT_MATCHED_USAGE_WORKS_JOB_TYPE, OUTPUT_TYPE_TITLE, HIGH_WATER_MARK_KEY, HIGH_WATER_MARK_TITLE, DISTRIBUTION_KEY, DISTRIBUTION_TITLE_PLURAL } from "../../Consts";
import { getOpenDistributionsThunk, getAllDistributionsThunk, getPoolsThunk } from "../../../redux/thunks/HomeThunks";
import { IUsagePoolState } from "../../../redux/types/IUsagePoolState";
import { IDistributionState } from "../../../redux/types/IDistributionState";
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import { If } from "../../../core/components/If";
import DropdownDataInput from "../../../repertoire/components/dropdownDataInput/DropdownDataInput";

const POOL_ALL_KEY = 0;

export interface IExtractMatchedUsageWorksJobParametersProps {
    setManualJobParameters: (parameters: ITriggerManualJob) => void;
    getOpenDistributions: typeof getOpenDistributionsThunk;
    getAllDistributions: typeof getAllDistributionsThunk;
    getPools: typeof getPoolsThunk;
    openDistributions?: IDistributionState[];
    allDistributions?:IDistributionState[];
    pools?: IUsagePoolState[];
    highWaterMark?: string;
    isUseAllDistributionEnabled: boolean;
    handleIsUseAllDistributionCheckbox: () => void
}

interface IExtractMatchedUsageWorksJobParametersState {
    selectedOpenDistributionID: string;
    selectedPools: any[];
    selectedFileFormat: string;
}

export class ExtractMatchedUsageWorksJobParameters extends React.Component<
    IExtractMatchedUsageWorksJobParametersProps,
    IExtractMatchedUsageWorksJobParametersState
> {
    constructor(props: IExtractMatchedUsageWorksJobParametersProps) {
        super(props);

        this.state = {
            selectedOpenDistributionID: '',
            selectedPools: [],
            selectedFileFormat: 'csv',
        };
    }

    componentDidMount() {
        const {
            getPools,
            pools,
            getOpenDistributions,
            getAllDistributions,
            openDistributions,
            allDistributions
        } = this.props;

        if (!pools || pools.length === 0) getPools();
        if (!openDistributions || openDistributions.length === 0) getOpenDistributions();
        if (!allDistributions || allDistributions.length === 0) getAllDistributions();
    }

    handleDistributionChange(value) {
        this.setState({ selectedOpenDistributionID: value, selectedPools: [] }, this.setParams);
    }

    getDistributionCodeOptions() {

        const { openDistributions, allDistributions, isUseAllDistributionEnabled } = this.props;

        let filteredDistributions = [];
        let newDistribution = isUseAllDistributionEnabled ? allDistributions : openDistributions;
        let distributionCodes = [];

        filteredDistributions = newDistribution.filter(d => d.distributionPools.length > 0);

        if (filteredDistributions && filteredDistributions.length > 0) {
            distributionCodes = filteredDistributions.map((val) => {
                return {
                    code: `${val.distributionID}`,
                    description: `${val.distributionCode} - ${val.description}`
                };
            });
        }

        return distributionCodes;
    }

    setParams = () => {
        const { setManualJobParameters, highWaterMark} = this.props;
        const { selectedOpenDistributionID, selectedPools, selectedFileFormat} = this.state;

        const filteredPools = selectedPools.filter(sp => sp !== 0);
        const manualJobParameters: ITriggerManualJob = {
            jobType: EXTRACT_MATCHED_USAGE_WORKS_JOB_TYPE,
            jobParameters: JSON.stringify({ selectedOpenDistributionID, selectedPools: filteredPools, fileFormat: selectedFileFormat, hwm: highWaterMark }),
        };
        setManualJobParameters(manualJobParameters);
    }

    render() {
        const { openDistributions, allDistributions, pools, highWaterMark, isUseAllDistributionEnabled, handleIsUseAllDistributionCheckbox } = this.props;
        const { selectedPools, selectedOpenDistributionID, selectedFileFormat} = this.state;

        let filteredPools = [];
        let filteredDistributions = [];
        let newDistribution = isUseAllDistributionEnabled ?  allDistributions : openDistributions;

        filteredDistributions = newDistribution.filter(d => d.distributionPools.length > 0)

        if (selectedOpenDistributionID && pools) {
            const selectedDistribution = filteredDistributions.filter(d => d.distributionID === Number.parseInt(selectedOpenDistributionID))[0];
            filteredPools = pools.filter(p => selectedDistribution.distributionPools.map(dp => dp.poolID).indexOf(p.poolID) > -1);
        }

        let poolsOptions = [];
        let fileFormatOptions = [];

        fileFormatOptions.push(<option value="csv" title="CSV" key="csv" defaultValue={"CSV"}>CSV</option>);
        fileFormatOptions.push(<option value="json" title="JSON" key="json">JSON</option>);
        fileFormatOptions.push(<option value="native json" title="NATIVE JSON" key="native json">NATIVE JSON</option>);

        if (filteredPools && filteredPools.length > 0) {
            let poolsOptionsTemp = filteredPools.map(val => ({
                key: val.poolID,
                text: val.poolCode,
                data: val.poolCode
            }));
            
            poolsOptions = poolsOptions.concat(poolsOptionsTemp);
            poolsOptions.sort((a, b) => a.text.localeCompare(b.text));
            poolsOptions.unshift({ key: 0, text: "All", data: "All" });
        }     

        const multiSelectChangeData = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
            if (!option) return;

            let next = [...this.state.selectedPools];

            if (option.text === 'All') {
                next = option.selected
                ? poolsOptions.map(o => o.key) 
                : [];                                
            } else {
                if (option.selected && !next.includes(option.key)) next.push(option.key);
                if (!option.selected) next = next.filter(k => k !== option.key);
            }

            const individualKeys = poolsOptions
                .filter(o => o.key !== POOL_ALL_KEY)
                .map(o => o.key);

            const withoutAll = next.filter(k => k !== POOL_ALL_KEY);
            next = (withoutAll.length === individualKeys.length)
                ? [POOL_ALL_KEY, ...withoutAll]
                : withoutAll;

            next = Array.from(new Set(next));

            this.setState({ selectedPools: next }, this.setParams);
        }

        const onRenderPeriodDropdownTitle = (
            options: IDropdownOption[] | undefined
        ): JSX.Element => {
            const displayValue = options.filter(o => o.text !== 'All').map(o => o.text).join(", ");
            return (
                <div>
                    <span>{displayValue}</span>
                </div>
            );
        };

        return (
            <>
                <div className="ms-Dropdown-container form-group col-md-6 col-sm-6 col-xs-12">
                    <DropdownDataInput
                        label={DISTRIBUTION_TITLE_PLURAL}
                        fieldName={DISTRIBUTION_KEY}
                        changeData={this.handleDistributionChange.bind(this)}
                        value={selectedOpenDistributionID}
                        options={this.getDistributionCodeOptions()}
                        allowNull={false}
                        isHidden={false}
                        isMandatory={false}
                    />
                </div>
           
                 <div className="form-group closed-distribution-checkbox-container col-md-3 col-sm-6 col-xs-12">
                    <div className="checkboxContainer">
                        <label className="subContainer">
                            <input type="checkbox" id="customRange" 
                                checked={isUseAllDistributionEnabled}
                                onChange={handleIsUseAllDistributionCheckbox} />
                            <span className="inputCheckbox"></span>
                            <div className="checkboxLabel"> Include Closed Distribution </div>
                        </label>
                    </div>
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <Dropdown
                        label={"Pools"}
                        selectedKeys={selectedPools}
                        options={poolsOptions}
                        multiSelect={true}
                        onChange={multiSelectChangeData}
                        placeholder={""}
                        disabled={false}
                        required={true}
                        onRenderTitle={onRenderPeriodDropdownTitle}
                    />
                </div>

                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>{OUTPUT_TYPE_TITLE}</label>
                    <select required
                        onChange={(e) => {
                            this.setState({ selectedFileFormat: e.target.value }, () => {
                                this.setParams();
                            });
                        }}
                    >
                        {fileFormatOptions}
                    </select>
                </div>

                <If condition={selectedFileFormat === 'json' || selectedFileFormat =='native json'}>
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <TextDataInput
                            label={HIGH_WATER_MARK_TITLE}
                            fieldName={HIGH_WATER_MARK_KEY}
                            changeData={null}
                            value={highWaterMark}
                            readOnly={true}
                            isHidden={false}
                        />
                    </div>
                </If>
            </>
        );
    }
}
